export const businessUnits = {
  rsi: 'RSI',
  rtr: 'RTR',
  rts: 'RTS',
  srf: 'SRF',
  swi: 'SWI'
};
export const allBusinessUnits = Object.keys(businessUnits);
export const isBusinessUnit = value => businessUnits[value] !== undefined;
export const parseToBusinessUnit = value => isBusinessUnit(value) ? value : undefined;